import React, {
    Component
} from 'react';

import {
    connect
} from 'react-redux'

import {
    getPrices
} from '../selectors/index'

import classNames from 'classnames'

class TotalPrice extends Component {
    render() {
        const {prices, changed, priceTitleDefault = 'Starting from', priceTitleChanged = 'Total price', currency = '€'} = this.props;
        const classes = classNames('price', {
            'price-changed': changed
        })
        return (
            <span>
                <span className="price-title">{prices.boat === prices.total ? priceTitleDefault : priceTitleChanged}</span>
                <span className={classes}>{prices.total}{currency}</span>
            </span>
        );
    }
}

const mapStateToProps = (state) => ({
    prices: getPrices(state),
    changed: state.hasChanged,
    currency: state.currency
});

export default connect(mapStateToProps)(TotalPrice);



// WEBPACK FOOTER //
// ./src/components/TotalPrice.js